module.exports = __webpack_public_path__ + "assets/logo_vertical_old1.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/logo_vertical_old1.png
 ** module id = 228
 ** module chunks = 1
 **/